import { PlayRepeat, SourceLabelType, SourceType } from "type/panel/Panel.type";

export const PANEL_PER_PAGE_MAX = 5;

export const AREA_EDIT_COLORS = [
  "orange",
  "green",
  "blue",
  "yellow",
  "aquamarine",
  "Bisque",
  "DarkTurquoise",
  "HotPink",
  "Ivory",
  "LightGreen",
];

export const AREA_EDIT_DEFAULT_COLOR = "LightGray";

export const SOURCE_TYPE_VALUES: { [key: string]: SourceType } = {
  VIDEO: "video",
  TEXT: "text",
  PHOTO: "photo",
  AUDIO: "audio",
};

export const AREA_SOURCE_TYPES: SourceLabelType[] = [
  { label: "video", value: SOURCE_TYPE_VALUES.VIDEO },
  { label: "text", value: SOURCE_TYPE_VALUES.TEXT },
  { label: "photo", value: SOURCE_TYPE_VALUES.PHOTO },
];

export const PLAY_REPEAT: { [key: string]: Partial<PlayRepeat> } = {
  NO: "no",
  LOOP: "loop",
};
